import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Spacer = styled.div`
  height: ${props => props.h};

  @media (${theme.bp.mobileL}) {
    height: ${props => props.mobileL || props.h};
  }
`;
